<template>
  <!--
      作者：gmshop
      时间：2019-10-25
      描述：应用-小程序设置
  -->
  <div class="product-add">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="250px">
      <!--小程序设置-->
      <div class="common-form">小程序设置</div>

      <el-form-item label="AppID 小程序ID">
        <el-input v-model="form.wxapp_id" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="AppSecret 小程序密钥">
        <el-input v-model="form.wxapp_secret" type="password" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="服务器地址" :label-width="formLabelWidth">
          <el-button @click="copy()" type="text" size="small">点击复制链接</el-button>
      </el-form-item>
      <el-form-item label="Token(令牌)">
        <el-input v-model="form.token" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="EncodingAESKey(消息加密密钥)">
        <el-input v-model="form.aes_key" class="max-w460"></el-input>
      </el-form-item>
      


      <div class="common-form">微信支付设置</div>
      <el-form-item label="商户号类型">
        <el-radio v-model="form.pay_type" :label="0">普通商户号支付</el-radio>
        <el-radio v-model="form.pay_type" :label="10">小程序支付管理服务</el-radio>
        <div class="gray">
          小程序支付管理服务的 商户支付方式和普通支付方式不同，请勿随意切换
        </div>
      </el-form-item>
      <el-form-item label="微信支付商户号 MCHID">
        <el-input v-model="form.mchid" class="max-w460"></el-input>
      </el-form-item>
      <div class="common-form">V2版本设置</div>
      <el-form-item label="微信支付密钥 APIKEY">
        <el-input v-model="form.apikey" class="max-w460"></el-input>
      </el-form-item>
      
      <el-form-item label="apiclient_cert.pem">
        <el-input type="textarea" :rows="4" placeholder="使用文本编辑器打开apiclient_cert.pem文件，将文件的全部内容复制进来" v-model="form.cert_pem" class="max-w460"></el-input>
        <div class="tips">使用文本编辑器打开apiclient_key.pem文件，将文件的全部内容复制进来</div>
      </el-form-item>
      <el-form-item label="apiclient_key.pem">
        <el-input type="textarea" :rows="4" placeholder="使用文本编辑器打开apiclient_cert.pem文件，将文件的全部内容复制进来" v-model="form.key_pem" class="max-w460"></el-input>
        <div class="tips">使用文本编辑器打开apiclient_key.pem文件，将文件的全部内容复制进来</div>
      </el-form-item>
      <div class="common-form">V3版本设置</div>
      <el-form-item label="微信支付密钥 APIKEY">
        <el-input v-model="form.apikey_v3" class="max-w460"></el-input>
      </el-form-item>
      
      <el-form-item label="apiclient_cert.pem">
        <el-input type="textarea" :rows="4" placeholder="使用文本编辑器打开apiclient_cert.pem文件，将文件的全部内容复制进来" v-model="form.cert_pem_v3" class="max-w460"></el-input>
        <div class="tips">使用文本编辑器打开apiclient_key.pem文件，将文件的全部内容复制进来</div>
      </el-form-item>
      <el-form-item label="apiclient_key.pem">
        <el-input type="textarea" :rows="4" placeholder="使用文本编辑器打开apiclient_cert.pem文件，将文件的全部内容复制进来" v-model="form.key_pem_v3" class="max-w460"></el-input>
        <div class="tips">使用文本编辑器打开apiclient_key.pem文件，将文件的全部内容复制进来</div>
      </el-form-item>

      <!--提交-->
      <div class="common-button-wrapper">
          <el-button type="primary" @click="onSubmit">提交</el-button>
      </div>
    </el-form>


  </div>

</template>

<script>
  import AppSettingApi from '@/api/appsetting.js';

  export default {
    data() {
      return {
        /*切换菜单*/
        // activeIndex: '1',
        /*form表单数据*/
        form: {
        },
        url:window.origin+'/index.php/job/wechat/notify?app_id='

      };
    },
    created() {
      this.getData()
    },

    methods: {
      copy() {
          var copyContent = document.createElement('input');     //创建一个隐藏input（重要！）
          copyContent.value = window.location.protocol + '//' + window.location.host + "/index.php/job/wechat/notify?app_id=" + this.form.app_id;    //拼接多个赋值
          document.body.appendChild(copyContent);
          copyContent.select(); // 选择对象
          document.execCommand("Copy"); // 执行浏览器复制命令
          this.$message.success("复制成功！");
          copyContent.remove();
      },
      getData() {
        let self = this;
        AppSettingApi.appwxDetail({}, true)
          .then(data => {
            if(data.data.data != null){
              self.form = data.data.data;
            }
          })
          .catch(error => {});

      },
      //提交表单
      onSubmit() {
        let self = this;
        let params = this.form;
        AppSettingApi.editAppWx(params, true)
          .then(data => {
            self.$message({
              message: '恭喜你，设置成功',
              type: 'success'
            });
            self.$router.push('/appsetting/appwx/index');
          })
          .catch(error => {

          });
      },
    }

  };
</script>

<style>
  .tips {
    color: #ccc;
  }
</style>



// WEBPACK FOOTER //
// src/views/appsetting/appwx/index.vue